import { useQuery } from "@tanstack/react-query";
import { statsApi } from "../../api/stats";

export const statsKeys = {
  all: ["stats"] as const,
  homepage: () => ["stats", "homepage"] as const,
  hallOfFame: (ladderId: number | string | null | undefined) =>
    ["stats", "hall-of-fame", ladderId] as const,
};

export const useHomepageStats = () =>
  useQuery({
    queryKey: statsKeys.homepage(),
    queryFn: statsApi.homepage,
    staleTime: 60_000,
  });

export const useHallOfFame = (ladderId: number | string) =>
  useQuery({
    queryKey: statsKeys.hallOfFame(ladderId),
    queryFn: () => statsApi.hallOfFame(Number(ladderId)),
    staleTime: 60_000,
  });
